import { InventoryColumnIds } from "../../utilities/IngredientsTableColumn";
import { RegulationManager } from "./RegulationManager";

export interface RegulationDependentBomColumn {
    columnId: string;
    requiredInLeafRows: boolean,
    requiredInNonSummaryNonLeafRows: boolean,
    requiredInSummaryRow: boolean
}

export class RegulationDependentBomColumnsManager {
    static RegulationDependentBomColumns: { [regulationId: string]: RegulationDependentBomColumn[] } = {
        [RegulationManager.ReachSvhcAuthorizationV2RegulationId]: [
            {
                columnId: InventoryColumnIds.ReachNumber,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            }
        ],
        [RegulationManager.ScipComplianceId]: [
            {
                columnId: InventoryColumnIds.ScipConcernElementMixtureCategory,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            },
            {
                columnId: InventoryColumnIds.ScipConcernElementMaterialCategory,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            },
            {
                columnId: InventoryColumnIds.ComponentPercentByWeight,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            },
            {
                columnId: InventoryColumnIds.Quantity,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            }
        ],
        [RegulationManager.ReachClpPbtRegulationId]: [
            {
                columnId: InventoryColumnIds.PbtOrVpvb,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            },
            {
                columnId: InventoryColumnIds.CLPClassification,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            }
        ],
        [RegulationManager.Tsca8a7RegulationId]: [
            {
                columnId: InventoryColumnIds.PhysicalState,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            },
            {
                columnId: InventoryColumnIds.TscaAccession,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            },
            {
                columnId: InventoryColumnIds.Pmn,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            },
            {
                columnId: InventoryColumnIds.OecdCode,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            },
            {
                columnId: InventoryColumnIds.AuthorisationGranted,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            }
        ],
        [RegulationManager.InternationalPfasRegulationId]: [
            {
                columnId: InventoryColumnIds.Casrn,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            },
            {
                columnId: InventoryColumnIds.PercentByWeight,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            },
            {
                columnId: InventoryColumnIds.PhysicalState,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            },
            {
                columnId: InventoryColumnIds.TscaAccession,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            },
            {
                columnId: InventoryColumnIds.Pmn,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            },
            {
                columnId: InventoryColumnIds.Role,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            },
            {
                columnId: InventoryColumnIds.OecdCode,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            },
            {
                columnId: InventoryColumnIds.ConfidentialBusinessInformation,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            },
            {
                columnId: InventoryColumnIds.TotalOrganicFluorineContent,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            }
        ],
        [RegulationManager.ReachSvhcAuthorizationRegulationId]: [
            {
                columnId: InventoryColumnIds.AuthorisationGranted,
                requiredInLeafRows: false,
                requiredInNonSummaryNonLeafRows: false,
                requiredInSummaryRow: false
            }
        ]
    };
}
